<template>
	<div class="container">
		<section class="mobile_cs">
			<div class="sub_content1 d_flex justify_center align_items_center">
				<h2 class="title">
					{{ $t('cs.title') }}
				</h2>
			</div>
		</section>
		<div class="content cs">
			<p class="title">{{ $t('cs.inquiry.inquiry') }}</p>
			<form class="q_write" autocomplete="off" @submit.prevent>
				<label>{{ $t('input.label.email') }}</label>
				<input
					type="email"
					:placeholder="$t('input.placeholder.email')"
					class="mb_10 mt_10"
					v-model="emailAddress"
				/>
				<label>{{ $t('input.label.password') }}</label>
				<input
					type="password"
					:placeholder="$t('input.placeholder.password')"
					class="mb_10 mt_10"
					v-model="password"
				/>
				<label>{{ $t('input.label.inquiry_type') }}</label>
				<div class="select_wrap mb_10 mt_10">
					<select class="contact_type" v-model="typeSeq">
						<option value="" selected disabled>
							{{ $t('cs.placeholder.type') }}
						</option>
						<option
							v-for="item in ticketTypeList"
							:key="item.seq"
							:value="item.seq"
						>
							{{ item.title }}
						</option>
					</select>
				</div>
				<label>{{ $t('input.label.enter_subject') }}</label>
				<input
					type="text"
					:placeholder="$t('cs.placeholder.title')"
					class="mb_10 mt_10"
					v-model="title"
				/>
				<label>{{ $t('input.label.inquiry_content') }}</label>
				<textarea
					class="ask mt_10"
					:placeholder="$t('cs.placeholder.content')"
					v-model="content"
				></textarea>
				<div class="inquiry_button_area">
					<button class="mr_10 m_button">{{ $t('button.cancel') }}</button>
					<button class="button_bg_red m_button" @click="registTicket">
						{{ $t('button.confirm') }}
					</button>
				</div>
			</form>
		</div>
	</div>
	<ModalViewM
		v-if="pinCodeModal"
		@closeModal="pinCodeModal = false"
		add-class="tal"
	>
		<template #title>
			<h3 class="modal_title_m tal">{{ $t('cs.ticket.id') }}</h3>
		</template>
		<div>
			<p class="mb_20 fs_14 fc_gray_1">
				{{ $t('cs.ticket.text1') }}
			</p>
			<label class="pin_number mb_50" for="pin_number">
				<input
					v-model="ticketId"
					id="pin_number"
					type="text"
					readonly
					class="tac"
					@click="copyTicketId" /><span class="copy_icon"></span
			></label>
			<div class="modal_button_area_m">
				<button @click="pinCodeModal = false">
					{{ $t('button.cancel') }}
				</button>
				<button class="fc_red" @click="goList">
					{{ $t('button.confirm') }}
				</button>
			</div>
		</div>
	</ModalViewM>
</template>

<script>
import { createTicket, fetchTicketTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';
import ModalViewM from '@/components/Layout/ModalView.m';
import useClipboard from 'vue-clipboard3';

export default {
	name: 'Inquiry.m',
	components: { ModalViewM },
	data() {
		return {
			parentSeq: '',
			typeSeq: '',
			title: '',
			content: '',
			emailAddress: '',
			password: '',
			fieldValues: [],
			ticketTypeList: [],
			ticketId: '',
			pinCodeModal: false,
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadTicketTypeList();
		},
		async loadTicketTypeList() {
			const { data } = await fetchTicketTypes().catch(commonError);
			this.ticketTypeList = data;
		},
		async registTicket() {
			const params = {
				parent_seq: this.parentSeq,
				type_seq: this.typeSeq,
				title: this.title,
				content: this.content,
				email_address: this.emailAddress,
				password: this.password,
				field_values: this.fieldValues,
			};
			await createTicket(params)
				.then(result => {
					this.ticketId = result.ticket_id;
					this.pinCodeModal = true;
				})
				.catch(commonError);
		},
		copyTicketId() {
			try {
				useClipboard().toClipboard(this.ticketId);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
		goList() {
			this.$router.push({ name: 'inquiry_detail' });
		},
	},
};
</script>

<style scoped>
.m_inquiry .container {
	margin-bottom: 0;
}
section.mobile_cs .title {
	font-size: 30px;
	line-height: 1.2;
}
.mobile_cs .sub_content1 {
	width: 100%;
	min-height: 250px;
	margin: 0 auto;
	color: #fff;
	background-size: cover;
	background: #000 url('~@/assets/images/sub/cs.png') no-repeat 43% 0;
}
.content.cs {
	width: 100%;
	padding: 30px 16px;
	min-height: 300px;
	background: #fff;
}
.content.cs .title {
	padding-bottom: 25px;
	font-size: 24px;
	line-height: 1.2;
	font-weight: bold;
	text-align: center;
}
.m_inquiry .ask {
	min-height: 126px;
}
.m_inquiry label {
	font-size: 14px;
}
.m_inquiry input::placeholder,
.m_inquiry select,
.m_inquiry textarea::placeholder {
	font-size: 14px;
}
.pin_number {
	position: relative;
}
.copy_icon {
	position: absolute;
	display: block;
	top: 50%;
	transform: translateY(-50%);
	right: 15px;
	width: 16px;
	height: 16px;
	background: url('~@/assets/images/icon/copy.png') no-repeat;
	background-size: cover;
	cursor: pointer;
}
.m_inquiry .fc_gray_1 {
	color: #919191;
}
.m_button {
	min-width: 74px;
}
</style>
